/**
 * Project type definitions for organizing chats with custom instructions
 */

export interface Project {
  id: string
  name: string
  custom_instructions: string  // snake_case to match backend
  created_at: string           // ISO timestamp
  updated_at: string           // ISO timestamp
  chat_count?: number
}

// Frontend-friendly alias with camelCase
export interface ProjectDisplay {
  id: string
  name: string
  customInstructions: string
  createdAt: string
  updatedAt: string
  chatCount?: number
}

// Convert backend response to frontend format
export const toProjectDisplay = (p: Project): ProjectDisplay => ({
  id: p.id,
  name: p.name,
  customInstructions: p.custom_instructions,
  createdAt: p.created_at,
  updatedAt: p.updated_at,
  chatCount: p.chat_count
})

/**
 * Project File type definition for file attachments
 */
export interface ProjectFile {
  id: string
  project_id: string
  user_id: string
  filename: string
  blob_url: string
  content_type: string | null
  file_size: number
  created_at: string
}

export type OperationResult<T> = { data: T; error: null } | { data: null; error: string }
